var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "11px",
    viewBox: "0 0 13 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fill 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sprint-1-/-Abgabe",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XLg_Nav-Level1_tooltip",
    transform: "translate(-1251.000000, -64.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(1243.000000, 53.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "overlay",
    transform: "translate(0.000000, 4.555556)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(8.852941, 5.857143)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8039216,1.88325993 C11.3697586,2.09227468 10.9027659,2.23361991 10.4129032,2.29728532 C10.9130944,1.97175085 11.2970907,1.4568218 11.4778382,0.842991122 C11.0101078,1.14410049 10.491473,1.36272512 9.94000858,1.48084648 C9.49809926,0.969921535 8.8688027,0.650793651 8.17237132,0.650793651 C6.83483946,0.650793651 5.75072304,1.82760275 5.75072304,3.27949448 C5.75072304,3.48530594 5.77211765,3.68591205 5.81343137,3.87850993 C3.80049387,3.76879721 2.01625735,2.72212181 0.821848039,1.13168774 C0.613435049,1.5200868 0.493920343,1.97175085 0.493920343,2.45344577 C0.493920343,3.36518252 0.921443627,4.17000943 1.57102819,4.64129365 C1.17412132,4.62767966 0.800822304,4.5095583 0.474370098,4.31255589 C0.474001225,4.32376741 0.474001225,4.33457852 0.474001225,4.34579003 C0.474001225,5.61949869 1.3087598,6.68179013 2.41685294,6.92323821 C2.21360417,6.98329992 1.99965809,7.01533283 1.77870343,7.01533283 C1.62267034,7.01533283 1.47106373,6.99891596 1.32314583,6.96848469 C1.63115441,8.01275762 2.52567034,8.77273845 3.58544118,8.79396026 C2.75658456,9.49908473 1.71230637,9.91911629 0.577654412,9.91911629 C0.382151961,9.91911629 0.18960049,9.90670353 9.43558956e-14,9.88267885 C1.07157475,10.6282449 2.34455392,11.0634921 3.71233333,11.0634921 C8.16683824,11.0634921 10.6025037,7.05777644 10.6025037,3.58420755 C10.6025037,3.47009031 10.6002904,3.35677388 10.5954951,3.24385787 C11.0687586,2.87347732 11.4793137,2.41060175 11.8039216,1.88325993",
    id: "Fill-1"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTwitter);
export default __webpack_public_path__ + "static/media/icon-twitter.593e497f.svg";
export { ForwardRef as ReactComponent };